<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-8" to="/">
                <img src="img/brand/white.png" alt="logo">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="#">
                        <img src="img/brand/blue.png">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>
            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <span class="nav-link-inner--text text-white">Contato:</span>
                <li class="nav-item" />
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="tel:558141418193"
                       data-toggle="tooltip" title="Ligue para a gente">
                        <i class="fa fa-phone fa-2x"></i>
                        <span class="nav-link-inner--text d-lg-none">Telefone</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://api.whatsapp.com/send?phone=5581996923377" target="_blank" 
                       data-toggle="tooltip" title="Fale conosco no whatsapp">
                        <i class="fa fa-whatsapp fa-2x"></i>
                        <span class="nav-link-inner--text d-lg-none">Whatsapp</span>
                    </a>
                </li>                
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="mailto:contato@recifeadministradora.com.br" 
                       data-toggle="tooltip" title="Fale conosco via e-mail">
                        <i class="fa fa-envelope fa-2x"></i>
                        <span class="nav-link-inner--text d-lg-none">Email</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://www.instagram.com/recifeadm"
                       target="_blank" rel="noopener" data-toggle="tooltip" title="Siga a gente no instagram">
                        <i class="fa fa-instagram fa-2x "></i>
                        <span class="nav-link-inner--text d-lg-none">Instagram</span>
                    </a>
                </li>
                <li class="nav-item d-none d-lg-block ml-lg-4">
                    <a href="#" @click="validaLogin"
                       class="btn btn-neutral btn-icon">
                        <span class="btn-inner--icon">
                        <i class="ni ni-app mr-2"></i>
                        </span>
                        <span class="nav-link-inner--text">Área do Condômino</span>
                    </a>
                    <modal :show.sync="modals.modal3"
                        body-classes="p-0"
                        modal-classes="modal-dialog-centered modal-sm">
                        <card type="secondary" shadow
                            header-classes="bg-white pb-5"
                            body-classes="px-lg-5 py-lg-5"
                            class="border-0">
                            <template>
                                <div class="text-center text-muted mb-4">
                                    <h5>Insira suas credenciais para logar</h5>
                                </div>
                                
                                <form role="form">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <input ref="email" type="email" v-model="email" class="form-control" id="exampleFormControlInput1" placeholder="email"  >
                                            </div>
                                            <div class="form-group">
                                                <input type="password" v-model="senha" class="form-control" id="exampleFormControlInput2" placeholder="senha">
                                            </div>
                                            <div class="text-center">
                                                <base-button type="primary" class="my-4" @click="validaLogin()">Logar</base-button>
                                            </div>
                                            <div class="text-center">
                                                <h7 class="text-warning" v-if="invalido">Dados de Login Incorretos</h7>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </form>
                            </template>
                        </card>
                    </modal>
                </li>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import Modal from "@/components/Modal.vue";
import axios from 'axios';
export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
    Modal
  },
  data() {
    return {
      modals: {
        modal3: false
      },
      invalido: false,
      email: '',
      senha: ''
    };
  },
  methods: {
    validaLogin() {
      this.invalido = false;
       window.open(
            'https://recifeadministr.superlogica.net/clients/areadocondomino',
            '_self'
          )
    }
  }
};
</script>
<style>
</style>
